import { get_user_id_and_name_from_slug } from '$lib/util';

/**
 * @param {string} param
 * @return {param is string}
 * @satisfies {import('@sveltejs/kit').ParamMatcher}
 */
export function match(param) {

	const { user_id, name } = get_user_id_and_name_from_slug('@' + param);

	// Valid if we have either a user_id or a name
	if (user_id !== undefined) {
		return true;
	}

	if (name !== undefined) {
		// Additional check to ensure name contains only valid characters
		return /^[a-zA-Z]+$/.test(name);
	}

	return false;
}